import Hero from "../Component/Hero";
import PengajuanPinjaman from "../Component/PengajuanPinjaman";
import PersyaratanPinjaman from "../Component/PersyaratanPinjaman";
import React from "react";
import CardDokumenPendukung from "../Component/CardDokumenPendukung";
import Table from "../Component/Table";

function InvoiceFinancing() {
    return (
        <>
            <div>
                <Hero
                    imageClass='developer-financing'
                    title='<em>Developer Financing</em>'
                    subTitle='P I N J A M A N &emsp;P R O D U K T I F'
                    explanation='
                    Fasilitas pinjaman yang ditawarkan kepada pengembang <em>property</em> sebagai Pelaku Usaha dimana penggunaannya diperuntukan sebagai modal dalam proyek konstruksi perumahan dengan skema pembayaran yang fleksibel.'
                    buttonText='AJUKAN PINJAMAN'
                    buttonCompanyWeb={true}
                />
                <Table type='produktif' title='developer'/>
                <PersyaratanPinjaman type='produktif'/>
                <CardDokumenPendukung type='produktif'/>
                <PengajuanPinjaman type='produktif'/>
            </div>
        </>
    );
}

export default InvoiceFinancing;
